import { useEffect, useMemo, useState } from "react"
import { useQuery } from "./useQuery"
import { useDispatch, useSelector } from "react-redux"
import { Shared } from "../components"
import Popup from "reactjs-popup"
import { setModal } from "../actions"

export const useTableColumnsManager = ({ defaultFields, type }) => {
    const dispatch = useDispatch()
    const { handleUrlChange } = useQuery()

    const [currentFields, setCurrentFields] = useState(defaultFields)
    const [lockedColumns, setLockedColumns] = useState([])

    const { filterPresets } = useSelector(({ general }) => general?.user) || {}
    const selectedFilterPreset = useMemo(() => filterPresets?.filter((f) => f.type === type).find(({ applied }) => applied), [filterPresets, type])

    const setPreset = (preset) => {
        const { lockedColumns, fields, sort, filter } = preset
        setCurrentFields(fields)
        setLockedColumns(lockedColumns)
        handleUrlChange({ sort, filter })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { if (selectedFilterPreset) setPreset(selectedFilterPreset?.preset ?? {}) }, [selectedFilterPreset])

    const props = { defaultFields, currentFields, setCurrentFields, lockedColumns, type, setLockedColumns, selectedFilterPreset, setPreset }

    const manageColumns = () => dispatch(setModal({ isOpen: true, type: 'TableColumnsManager', props: { defaultFields, currentFields, onSuccess: setCurrentFields } }))
    const useColumnsManager = { lockedColumns, setLockedColumns }

    const handleFilterPresets = () => {
        return <Popup
            position='top right'
            contentStyle={{ width: 'auto' }}
            trigger={<div className={`icon icon-filter${selectedFilterPreset ? '-green' : ''}`} />}>
            {(close) => <Shared.TableFilterPresets close={close} {...props} manageColumns={manageColumns} />}
        </Popup>
    }


    return { currentFields, useColumnsManager, handleFilterPresets }

}